var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroadcast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3494",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2399",
    "data-name": "Group 2399",
    transform: "translate(-1201 -177)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1201, 177)",
    filter: "url(#Rectangle_3494)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3494-2",
    "data-name": "Rectangle 3494",
    width: 50,
    height: 50,
    rx: 5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cell_tower_black_24dp",
    transform: "translate(1216 189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2396",
    "data-name": "Group 2396"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3492",
    "data-name": "Rectangle 3492",
    width: 39,
    height: 39,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3493",
    "data-name": "Rectangle 3493",
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2398",
    "data-name": "Group 2398",
    transform: "translate(3.25 5.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2397",
    "data-name": "Group 2397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8413",
    "data-name": "Path 8413",
    d: "M9.525,19.37l.146-.146a1.244,1.244,0,0,0,.13-1.641,8.03,8.03,0,0,1-1.739-4.875,7.775,7.775,0,0,1,1.69-4.891,1.228,1.228,0,0,0-.114-1.657l-.114-.114a1.306,1.306,0,0,0-1.95.13A10.745,10.745,0,0,0,5.3,12.707,10.745,10.745,0,0,0,7.575,19.24,1.306,1.306,0,0,0,9.525,19.37Z",
    transform: "translate(0.063 -1.764)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8414",
    "data-name": "Path 8414",
    d: "M18.7,3.63l-.13.13a1.3,1.3,0,0,0-.049,1.755,13.784,13.784,0,0,1,0,17.388,1.379,1.379,0,0,0,.13,1.852h0a1.366,1.366,0,0,0,2.015-.114,15.979,15.979,0,0,0,3.705-10.433A16.49,16.49,0,0,0,20.618,3.76,1.3,1.3,0,0,0,18.7,3.63Z",
    transform: "translate(8.128 -3.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8415",
    "data-name": "Path 8415",
    d: "M7.8,3.76l-.13-.13a1.3,1.3,0,0,0-1.917.13,16.419,16.419,0,0,0,0,20.9,1.283,1.283,0,0,0,1.917.13l.13-.13A1.3,1.3,0,0,0,7.85,22.9a13.784,13.784,0,0,1,0-17.388A1.3,1.3,0,0,0,7.8,3.76Z",
    transform: "translate(-2 -3.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8416",
    "data-name": "Path 8416",
    d: "M16.248,19.321a1.355,1.355,0,0,0,2.048-.146,10.681,10.681,0,0,0,2.226-6.467,11.881,11.881,0,0,0-2.275-6.516,1.3,1.3,0,0,0-1.95-.146l-.13.13a1.244,1.244,0,0,0-.13,1.641,8.194,8.194,0,0,1,1.722,4.891,7.82,7.82,0,0,1-1.641,4.842,1.326,1.326,0,0,0,.13,1.771Z",
    transform: "translate(6.616 -1.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8417",
    "data-name": "Path 8417",
    d: "M18.957,11.562A4.075,4.075,0,0,0,13.79,7.646a4.045,4.045,0,0,0-1.528,6.971L7.452,29.031a1.535,1.535,0,0,0,1.462,2.031h0a1.537,1.537,0,0,0,1.462-1.056l.731-2.194H18.7l.731,2.194a1.537,1.537,0,0,0,1.463,1.056h0a1.542,1.542,0,0,0,1.462-2.031l-4.81-14.414A4.013,4.013,0,0,0,18.957,11.562Zm-6.776,13,2.714-8.125,2.714,8.125Z",
    transform: "translate(1.355 -0.619)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast);
export default __webpack_public_path__ + "static/media/broadcast.ad163b44f26928d5cdbe85beda718fc5.svg";
export { ForwardRef as ReactComponent };